<div [id]="pageType()" class="grid min-h-screen grid-rows-[auto_1fr_auto]">
  <app-header class="sticky top-0 z-50" />
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-footer />
</div>
@defer (on idle) {
  <app-delayed-scripts />
}
